const config = {
    APP_ENV: 'staging',
    API: 'https://api.staging.trainheroic.com',
    URL_COACHHEROIC: 'https://coach.staging.trainheroic.com/admin/coach#',
    URL_MARKETPLACE: 'https://marketplace.staging.trainheroic.com',
    URL_COACHAPP: 'https://coachapp.staging.trainheroic.com/',
    URL_SUPPORT: 'https://support.trainheroic.com/hc/en-us',
    URL_PRICING: 'https://www.trainheroic.com/pricing/',
    URL_THANKS: 'https://www.trainheroic.com/thanks/',
    LOGIN: 'https://marketplace.staging.trainheroic.com/account/login',
    REDUX_LOGGER_ENABLED: false,
    ROLLBAR_ENV: 'account-staging',
    SESSION_NAME: 'staging-Session',
    SEGMENT_KEY: 'uFEHdDNIYi0n8LsmpK1RzFdtEqsMEwMF',
    AMBASSADOR_ID: '734a3122-d8cf-4c83-88b6-93407a46887b'
};

export default config;
